<template>
  <div>
    <nav-title />
    <div class="layout-main">
      <div class="filter">
        <el-input
          class="cl-middle-font-size"
          style="width: 300px; margin: 0 8px 0 0"
          suffix-icon="el-icon-search"
          size="small"
          v-model="name"
          placeholder="请输入创意名称"
        />
        <div class="alignment">
          <svg
            :class="{ 'svg-icon': true, active: blockDisplay }"
            aria-hidden="true"
            @click="setDisplay(true)"
          >
            <use xlink:href="#icon-block"></use>
          </svg>
          <svg
            :class="{ 'svg-icon': true, active: !blockDisplay }"
            aria-hidden="true"
            @click="setDisplay(false)"
          >
            <use xlink:href="#icon-table"></use>
          </svg>
        </div>
      </div>
      <div class="list">
        <el-table
          ref="table"
          :data="list"
          stripe
          width="100%"
          v-loading="loading"
          v-if="!blockDisplay"
        >
          <el-table-column prop="id" label="创意ID" width="69">
          </el-table-column>
          <el-table-column prop="name" label="创意名称"> </el-table-column>
          <el-table-column prop="templatePath" label="创意预览">
            <template slot-scope="scope">
              <div
                v-for="(data, index) in JSON.parse(scope.row.templatePath)"
                :key="index"
              >
                <img
                  :src="data"
                  style="max-height:50px;"
                  alt=""
                  @click="previewTemplate(data)"
                />
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="id" label="尺寸">
            <template slot-scope="scope">
              <div>
                {{ scope.row.width || '0' }} x {{ scope.row.height || '0' }}
              </div>
            </template>
          </el-table-column>
          <el-table-column min-width="94" prop="update_time" label="更新时间">
            <template slot-scope="scope">
              <p>
                {{ setMoment(scope.row.updatetime) }}
              </p>
            </template>
          </el-table-column>
          <el-table-column prop="id" label="操作" width="160">
            <template slot-scope="scope">
              <span
                class="action"
                @click="previewTemplate(getImage(scope.row))"
              >
                <svg class="svg-icon" aria-hidden="true">
                  <use xlink:href="#icon-preview"></use>
                </svg>
              </span>
              <span class="action" @click="download(scope.row)">
                <svg class="svg-icon" aria-hidden="true">
                  <use xlink:href="#icon-download"></use>
                </svg>
              </span>
              <span class="action" @click="editTemplate(scope.row)">
                <svg class="svg-icon" aria-hidden="true">
                  <use xlink:href="#icon-edit"></use>
                </svg>
              </span>
              <span class="action" @click="remove(scope.row.id)">
                <svg class="svg-icon" aria-hidden="true">
                  <use xlink:href="#icon-delete"></use>
                </svg>
              </span>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <list-row
        :gutter="24"
        :width="204"
        v-loading="loading"
        v-if="blockDisplay"
      >
        <list-col v-for="item in list" :key="item.id">
          <div class="item">
            <div class="mask-wrap">
              <div class="content" @click="previewTemplate(getImage(item))">
                <img :src="getImage(item)" alt="" />
              </div>
              <div class="mask-item">
                <div class="button" @click="previewTemplate(getImage(item))">
                  <svg class="svg-icon" aria-hidden="true">
                    <use xlink:href="#icon-preview"></use>
                  </svg>
                </div>
                <div class="button">
                  <svg
                    class="svg-icon"
                    aria-hidden="true"
                    @click="download(item)"
                  >
                    <use xlink:href="#icon-download"></use>
                  </svg>
                </div>
                <div class="button" @click="editTemplate(item)">
                  <svg class="svg-icon" aria-hidden="true">
                    <use xlink:href="#icon-edit"></use>
                  </svg>
                </div>
                <div class="button" @click="remove(item.id)">
                  <svg class="svg-icon" aria-hidden="true">
                    <use xlink:href="#icon-delete"></use>
                  </svg>
                </div>
              </div>
            </div>
            <div class="info">
              <div class="name">{{ item.name }}</div>
              <div class="size">
                {{ item.width || '0' }}x{{ item.height || '0' }}
              </div>
            </div>
          </div>
        </list-col>
      </list-row>
      <div class="pagination">
        <el-pagination
          class="cl-pagination"
          background
          layout="prev, pager, next , sizes"
          @size-change="handleSizeChange"
          @current-change="handleChangePage"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="10"
          :total="total"
          :current-page.sync="$store.state[namespace].page"
        >
        </el-pagination>
      </div>
      <el-dialog class="preview-dialog" title="预览" :visible.sync="preview">
        <div class="content">
          <img :src="previewSvg" alt="" />
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import NavTitle from 'components/NavTitle';
import Row from 'components/List/Row';
import Col from 'components/List/Col';
import ListMixins from 'mixins/list';
import _ from 'lodash';
import Axios from 'utils/axios';
import moment from 'moment';

export default {
  name: 'DesignTemplateList',
  mixins: [ListMixins],
  data() {
    return {
      namespace: 'template',
      preview: false,
      previewSvg: '',
      name: '',
      blockDisplay: true,
      filterValues: { design_type: 1 }
    };
  },
  watch: {
    name() {
      this.queryList();
    }
  },
  components: {
    'nav-title': NavTitle,
    'list-row': Row,
    'list-col': Col
  },
  beforeDestroy() {
    this.$store.commit('template/update', {
      condition: {},
      list: [],
      total: 0,
      page: 1,
      pageSize: 10
    });
  },
  methods: {
    setMoment(data) {
      return moment(data).format('YYYY-MM-DD hh:mm:ss');
    },
    setDisplay(data) {
      this.blockDisplay = data;
    },
    getImage(data) {
      return _.get(JSON.parse(_.get(data, 'templatePath', '{}')), '["1"]', '');
    },
    remove(ids) {
      this.$confirm('是否删除?', '警告', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        this.$store
          .dispatch('template/delete', {
            ids: [ids]
          })
          .then(() => {
            this.$message.success('删除成功');
            this.refreshData();
          });
      });
    },
    download(item) {
      const href = this.getImage(item);
      window.open(href,'target','_blank');
    },
    queryList() {
      this.$store.commit('template/update', {
        condition: {
          name: this.name || undefined
        }
      });
      this.refreshData();
    },
    refreshData() {
      this.handleChangePage(1);
    },
    previewTemplate(data) {
      this.previewSvg = data;
      this.preview = true;
    },
    editTemplate(data) {
      this.$router.push('/works/site/' + data.id);
    }
  }
};
</script>

<style lang="scss" scoped>
.action {
  color: #3fb7ff;
  font-size: 16px;
  margin-right: 14px;
  :last-child {
    margin: 0;
  }
}
.filter {
  display: flex;
  margin-bottom: 20px;
  justify-content: space-between;
  align-items: center;
  .field {
    margin-right: 8px;
  }
  .alignment {
    display: flex;
    .svg-icon {
      color: #75808b;
      font-size: 19px;
      display: block;
      cursor: pointer;
      margin: 0 10px;
      &.active {
        color: #3fb7ff;
      }
    }
  }
}

.search {
  display: flex;
  justify-content: flex-start;
  flex-wrap: nowrap;

  > div {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
  }
}

.item {
  background: #fff;
  border-radius: 4px;
  overflow: hidden;
  margin-bottom: 20px;
  box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.04);
  border: solid 1px #e9edf0;
  .info {
    width: 204px;
    box-sizing: border-box;
    padding: 16px 14px;
    height: 69px;
    display: flex;
    flex-direction: column;
    background: #f4f6f8;
    .name {
      font-size: 14px;
      font-weight: 500;
      letter-spacing: -0.39px;
      color: rgba(0, 0, 0, 0.65);
      white-space: nowrap;
      text-align: left;
      flex: auto;
      overflow: hidden;
      text-overflow: ellipsis;
      height: 20px;
      line-height: 20px;
      display: inline-block;
      padding: 0;
    }
    .size {
      display: inline-block;
      height: 17px;
      line-height: 17px;
      font-size: 12px;
      font-weight: 500;
      letter-spacing: -0.33px;
      color: rgba(0, 0, 0, 0.35);
    }
  }
  .content {
    cursor: pointer;
    width: 204px;
    height: 200px;
    overflow: hidden;
    background: #ffffff;
    justify-content: center;
    display: flex;
    align-items: center;
    > img {
      max-width: calc(100% - 28px);
      max-height: calc(100% - 28px);
    }
  }
  .name {
    padding: 5px 0;
    text-align: center;
  }
}
.mask-wrap {
  position: relative;
  .mask-item {
    display: none;
    cursor: pointer;
    width: 100%;
    height: 65px;
    background-image: linear-gradient(
      to top,
      rgba(0, 0, 0, 0.8),
      rgba(0, 0, 0, 0)
    );
    position: absolute;
    bottom: 0;
    z-index: 2000;
    justify-content: center;
    align-items: flex-end;
    padding-bottom: 10px;
    .button {
      color: #fff;
      text-align: center;
      width: 30px;
      height: 30px;
      border-radius: 50%;
      background: rgba(0, 0, 0, 0.6);
      display: inline-block;
      font-size: 16px;
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 0 7px;
      &:hover {
        background: #3fb7ff;
      }
    }
  }
  &:hover {
    .mask-item {
      display: flex;
    }
  }
}
.preview-dialog {
  .content {
    width: 100%;
    max-height: 500px;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    > img {
      max-height: 500px;
      max-width: 100%;
    }
  }
}
.cl-pagination {
  padding-bottom: 0;
}
</style>
